export const roomIsLive = {
  type: "boolean"
};
